// The bubble directive allows bubbling of events from child components.
// Example: <my-component v-bubble.error />
// This will bubble error components through the parent.
export default {
  bind: (el, binding, vnode) => {
    Object.keys(binding.modifiers).forEach(event => {
      // Bubble events of Vue components
      if (vnode.componentInstance) {
        vnode.componentInstance.$on(event, (...args) => {
          vnode.context.$emit(event, ...args)
        })

      // Bubble events of native DOM elements
      } else {
        el.addEventListener(event, payload => {
          vnode.context.$emit(event, payload)
        })
      }
    })
  }
}
